export default __webpack_public_path__ + "static/media/turkish.96f8e98d.svg";